import { PAGE_STACK_DISPLAY_TYPE } from '@lighthouse/core'
import { WorkflowType } from '@lighthouse/shared'

export const workflowLabelMap: Record<WorkflowType, { label: string; icon: string; color: string }> = {
    automation: { label: '自动化', icon: 'FlowArrow', color: 'var(--color-green-500)' },
    action: { label: '动作流', icon: 'MouseClick', color: 'var(--color-blue-500)' },
    subProcess: { label: '子流程', icon: 'Reorder', color: 'var(--color-gray-500)' }
}

export const workflowOptions: { value: WorkflowType; label: string; icon: string; color: string }[] = [
    { value: WorkflowType.AUTOMATION, label: '新建自动化', icon: 'FlowArrow', color: 'var(--color-green-500)' },
    { value: WorkflowType.ACTION, label: '新建动作流', icon: 'MouseClick', color: 'var(--color-blue-500)' },
    { value: WorkflowType.SUB_PROCESS, label: '新建子流程', icon: 'Reorder', color: 'var(--color-gray-500)' }
]

export const PAGE_STACK_DISPLAY_TYPE_OPTIONS = [
    {
        label: '弹窗',
        value: PAGE_STACK_DISPLAY_TYPE.modal
    },
    {
        label: '侧边栏',
        value: PAGE_STACK_DISPLAY_TYPE.drawer
    },
    {
        label: '页面',
        value: PAGE_STACK_DISPLAY_TYPE.page
    }
]
